// extracted by mini-css-extract-plugin
module.exports = {"input-wrapper":"six-digits-code-form_input-wrapper__S16Le"};